import { Component, Input, ViewEncapsulation } from '@angular/core';
import { EmpireStateCode, WizumenProductV2 } from '../../../wizumen-models';

@Component({
  selector: 'wizumen-detail-item',
  template: `
    <div class="item-detail-wrapper">
      <i class="eva-3-icon-{{ product.icon }}-ui -eva-3-icon-{{!isDesktopWizumenV2 ? 'xsm' : 'md'}} icon-container {{resolveIconColor()}}" [ngClass]="{'flipped-icon': flippedIcon}"
      ></i>
      <div class="item-detail-container">
        <div *ngIf="product.name" class="eva-3-h5 item-detail-name">{{ product.name }}</div>
        <div *ngIf="product.label" class="item-detail-label eva-3-caption">
          {{ product.label }}
        </div>

        <div class="description-container">
          <ng-container *ngFor="let description of product.description">
            <p
              [innerHTML]="description"
              class="item-detail-description eva-3-body-2"
            ></p>
          </ng-container>
        </div>
      </div>
    </div>
  `,
  styleUrls: ['./wizumen-detail-item.component.scss'],
  encapsulation: ViewEncapsulation.None,
})
export class WizumenDetailItemComponent {
  @Input() moduleId: string;
  @Input() moduleIndex: number;
  @Input() uniqueId: string;
  @Input() product: WizumenProductV2;
  @Input() flippedIcon: boolean = false;
  @Input() isDesktopWizumenV2: boolean;


  resolveIconColor(): string {
    if (EmpireStateCode.CONFIRMED === this.product.product_status) {
      return '';
    }
    if (EmpireStateCode.OPEN === this.product.product_status) {
      return 'icon-warning';
    }

    return 'icon-alert'

  }
}
